/**
 * Unit colours by position in the plan, shared by the calendar and the unit lists. Every colour
 * keeps white text at 4.5:1 or better; a unit is always named too, never shown by colour alone.
 */
export const UNIT_COLORS = ['#285a48', '#1f5f8b', '#7a4a8c', '#9a4a2f', '#4f6320', '#8a3d5c', '#3d5a80', '#75550f'] as const;

export const unitColor = (index: number): string => UNIT_COLORS[((index % UNIT_COLORS.length) + UNIT_COLORS.length) % UNIT_COLORS.length]!;
